import { render, staticRenderFns } from "./paneInfo.vue?vue&type=template&id=a2e72240&"
import script from "./paneInfo.vue?vue&type=script&lang=js&"
export * from "./paneInfo.vue?vue&type=script&lang=js&"
import style0 from "./paneInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports